import _ from "lodash";
import LayoutUtils from "./LayoutUtils";

class NearbyElementGroupingStrategy {
  constructor(/** Object **/ config = {}) {
    this.config = config;
  }

  apply(/** BlockLayout **/ blockLayout) {
    let elements = blockLayout.elementData;

    _.each(elements, function (elementData) {
      let group = blockLayout.getElementGroup(elementData.id);

      if (group == null) {
        group = blockLayout.createGroup(elementData.id, elementData);

        _.each(elements, function (innerElementData) {
          //don't compare self
          if (innerElementData.id != elementData.id) {
            let rel = LayoutUtils.getRectRelationship(elementData.rect, innerElementData.rect);

            if (rel.contains || rel.contained || rel.overlap >= 0.2) {
              blockLayout.addElement(group, innerElementData.id, innerElementData);
            }
          }
        });
      }
    });
  }
}

export default NearbyElementGroupingStrategy;
